"use client"

import { useEffect } from "react"
import { useState } from "react"

import { cn } from "@/lib/utils"

export function ItemQuantityBadge({
  quantity,
  className,
  pulsating,
}: {
  quantity: number
  className?: string
  pulsating?: boolean
}) {
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null
  }

  return (
    <span
      className={cn(
        "absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full bg-lightGreen text-[10px] text-primary-foreground",
        className,
        pulsating && "animate-pulse"
      )}
    >
      {quantity}
    </span>
  )
}
